import { useOutletContext } from "react-router-dom";
import QRScanner from "./QRScanner";

function Scanner() {
    const { isScanning, setIsScanning, handleScan } = useOutletContext();
    return (
        <div className="card shadow-sm border-0 rounded-4">
            <div className="card-body p-4 p-md-5">

                <h6 className="fw-semibold mb-3">QR Scanner</h6>

                {!isScanning ? (
                    <button
                        className="btn btn-dark"
                        onClick={() => setIsScanning(true)}
                    >
                        Start Scan
                    </button>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        <QRScanner
                            onScanSuccess={(data) => {
                                handleScan(data);
                                setIsScanning(false);
                            }}
                        />

                        <button
                            className="btn btn-outline-danger"
                            onClick={() => setIsScanning(false)}
                        >
                            Stop Scan
                        </button>
                    </div>
                )}

            </div>
        </div>
    );
}

export default Scanner;